import { render, staticRenderFns } from "./EventManagementTable.vue?vue&type=template&id=4bc56cb6"
import script from "./EventManagementTable.vue?vue&type=script&lang=js"
export * from "./EventManagementTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports